import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import BrowseResources from './pages/BrowseResources';
import ResourceDetail from './pages/ResourceDetail';
import AIToolsDashboard from './pages/AIToolsDashboard';
import WorksheetGenerator from './pages/WorksheetGenerator';
import TestPaperGenerator from './pages/TestPaperGenerator';
import LessonPlanner from './pages/LessonPlanner';
import QuizGenerator from './pages/QuizGenerator';
import ActivityPlanner from './pages/ActivityPlanner';
import AdminDashboard from './pages/AdminDashboard';
import AdminHub from './pages/AdminHub';
import AdminUsers from './pages/AdminUsers';
import AdminUsageAnalytics from './pages/AdminUsageAnalytics';
import AdminPayments from './pages/AdminPayments';
import AdminPaymentSettings from './pages/AdminPaymentSettings';
import AdminSubscriptions from './pages/AdminSubscriptions';
import AdminTestimonials from './pages/AdminTestimonials';
import Login from './pages/Login';
import Pricing from './pages/Pricing';
import Payment from './pages/Payment';
import TeacherTips from './pages/TeacherTips';
import TeacherTipArticle from './pages/TeacherTipArticle';
import Account from './pages/Account';
import SubmitReview from './pages/SubmitReview';
import SubmitTestimonial from './pages/SubmitTestimonial';
import TestimonialFormStandalone from './pages/TestimonialFormStandalone';
import ParentPortal from './pages/ParentPortal';
import ParentPricing from './pages/ParentPricing';
import ParentTopicExplainer from './pages/ParentTopicExplainer';
import ParentActivitySuggester from './pages/ParentActivitySuggester';
import AssessmentHub from './pages/AssessmentHub';
import CreateMarkingProject from './pages/CreateMarkingProject';
import MarkingProjectDetail from './pages/MarkingProjectDetail';
import ReviewSubmission from './pages/ReviewSubmission';
import AnswerKeyTemplates from './pages/AnswerKeyTemplates';
import StudentReport from './pages/StudentReport';
import ClassAnalytics from './pages/ClassAnalytics';
import NewsletterAdmin from './pages/NewsletterAdmin';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import Contact from './pages/Contact';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import TrialBanner from './components/TrialBanner';
import ExitIntentPopup from './components/ExitIntentPopup';
import { Toaster } from './components/ui/sonner';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <TrialBanner />
      <ExitIntentPopup />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/browse" element={<BrowseResources />} />
        <Route path="/resources" element={<BrowseResources />} />
        <Route path="/resources/:id" element={<ResourceDetail />} />
        <Route path="/ai-tools" element={<AIToolsDashboard />} />
        <Route path="/ai-tools/worksheet-generator" element={<WorksheetGenerator />} />
        <Route path="/ai-tools/test-generator" element={<TestPaperGenerator />} />
        <Route path="/ai-tools/lesson-planner" element={<LessonPlanner />} />
        <Route path="/ai-tools/quiz-generator" element={<QuizGenerator />} />
        <Route path="/ai-tools/activity-planner" element={<ActivityPlanner />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/teacher-tips" element={<TeacherTips />} />
        <Route path="/teacher-tips/:article_id" element={<TeacherTipArticle />} />
        {/* Legacy route redirect */}
        <Route path="/teaching-tips" element={<TeacherTips />} />
        <Route path="/teaching-tips/:article_id" element={<TeacherTipArticle />} />
        <Route path="/login" element={<Login />} />
        <Route path="/account" element={<Account />} />
        <Route path="/submit-review" element={<SubmitReview />} />
        <Route path="/submit-testimonial" element={<SubmitTestimonial />} />
        <Route path="/feedback" element={<TestimonialFormStandalone />} />
        <Route path="/parent" element={<ParentPortal />} />
        <Route path="/parent-portal" element={<ParentPortal />} />
        <Route path="/parent/pricing" element={<ParentPricing />} />
        <Route path="/parent/topic-explainer" element={<ParentTopicExplainer />} />
        <Route path="/parent/activity-suggester" element={<ParentActivitySuggester />} />
        <Route path="/parent/worksheet-generator" element={<WorksheetGenerator />} />
        <Route path="/parent/quiz-generator" element={<TestPaperGenerator />} />
        <Route path="/parent/test-generator" element={<TestPaperGenerator />} />
        <Route path="/parent/resources" element={<BrowseResources />} />
        <Route path="/assessment" element={<AssessmentHub />} />
        <Route path="/assessment/create-project" element={<CreateMarkingProject />} />
        <Route path="/assessment/project/:project_id" element={<MarkingProjectDetail />} />
        <Route path="/assessment/review/:submission_id" element={<ReviewSubmission />} />
        <Route path="/assessment/report/:submission_id" element={<StudentReport />} />
        <Route path="/assessment/analytics/:project_id" element={<ClassAnalytics />} />
        <Route path="/assessment/templates" element={<AnswerKeyTemplates />} />
        <Route path="/admin/resources" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/usage-analytics" element={<AdminUsageAnalytics />} />
        <Route path="/admin/newsletter" element={<NewsletterAdmin />} />
        <Route path="/admin/testimonials" element={<AdminTestimonials />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/payment-settings" element={<AdminPaymentSettings />} />
        <Route path="/admin/subscriptions" element={<AdminSubscriptions />} />
        <Route path="/admin" element={<AdminHub />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
